import { FC, useCallback, useEffect, useRef, useState } from 'react';
import './SubjectHeader.scss';
import images from '../../assets/images';
import { useNavigate } from 'react-router-dom';
import { singleSessionType } from '../../pages/LiveClass/LiveClass';
import { Results } from '../TestPage/TestPage';
import { TEACHER_ROLE } from '../../utils/constants';
import { useAppSelector } from '../../redux/app/hooks';
import { getScreenDimensions } from '../../utils/helper';
import MobileHeader from '../MobileHeader/MobileHeader';
import { Tooltip } from '@mui/material';
import CommonSearch from '../Search/CommonSearch';

interface propsType {
  headerName: string;
  headerImage: string;
  backNavigation: {
    path: string;
    state: any;
  };
  setShowCreateScheduling?: (val: boolean) => void;
  showCreateScheduling?: boolean;
  tabName?: string;
  singleSessionDetail?: singleSessionType | undefined;
  setSingleSessionDetail?: any;
  setIsClickedSessionDetail?: (val: boolean) => void;
  subCategory?: string;
  setOpenPopup?: (val: boolean) => void;
  setShowResults?: (val: boolean) => void;
  results?: Results[];
  openPdf?: boolean;
  onClose?: any;
  openStudentAssignments?: boolean;
  setIsEdit?: (val: boolean) => void;
  backgroundColor: string;
  setClickedVideoUrl?: (val: string) => void;
  isChanged?: boolean;
  handleSearchDebounce?: any;
  searchValue?: string;
  setSearchValue?: any;
}
const SubjectHeader: FC<propsType> = ({ setIsClickedSessionDetail, singleSessionDetail, setSingleSessionDetail, headerName, headerImage, backNavigation, tabName, showCreateScheduling, setShowCreateScheduling, subCategory, setOpenPopup, setShowResults, results, openPdf, onClose, openStudentAssignments, setIsEdit, backgroundColor, setClickedVideoUrl, isChanged, handleSearchDebounce, searchValue, setSearchValue }) => {
  const { exitIcon, searchCloseIcon } = images;
  const navigate = useNavigate();
  const role = useAppSelector((state) => state.auth.role);
  const baseUrl = process.env.REACT_APP_FRONTEND_URL;
  const [isSearchClick, setisSearchClick] = useState<boolean>(false);

  const backNavigationCall = () => {
    const isQuestionBank = tabName === 'Questions Bank';
    if (!isQuestionBank && setOpenPopup) {
      if (results?.length) {
        setOpenPopup(true);
        // navigate(backNavigation.path, {state: { ...backNavigation?.state } })
      }
      else {
        navigate(backNavigation.path, { state: { ...backNavigation?.state } })
      }
      return;
    }
    if (setClickedVideoUrl) {
      setClickedVideoUrl('');
      return;
    }
    if (setIsEdit) {
      setIsEdit(false);
    }
    if (setShowResults) {
      setShowResults(false);
      return;
    }
    if (showCreateScheduling && setShowCreateScheduling) {
      setShowCreateScheduling(false);
    } else if (singleSessionDetail && setSingleSessionDetail) {
      if (setIsClickedSessionDetail) {
        setIsClickedSessionDetail(false);
      }
      setSingleSessionDetail(undefined);
    } else {
      if ((backNavigation.path === '/teacher-classroom') && (tabName === 'liveclass')) {
        navigate(backNavigation?.path, { state: { tabNumber: 1 } });
      } else {
        navigate(backNavigation?.path, { state: backNavigation?.state });
      }
    }
  }


  const textRef = useRef<HTMLDivElement>(null);
  const [isEllipsisActive, setIsEllipsisActive] = useState(false);

  // Function to check if text is truncated (ellipsis applied)
  const checkEllipsis = useCallback(() => {
    if (textRef.current) {
      setIsEllipsisActive(textRef.current.scrollWidth > textRef.current.clientWidth);
    }
  }, []);

  const handleSearchClick = () => {
    setisSearchClick(true);
  };

  const handleCloseSearch = () => {
    setSearchValue("");
    handleSearchDebounce("");
    setisSearchClick(false);
  };

  return (
    <div className='mobilesubjectHeader'>
      {(isSearchClick && getScreenDimensions()?.isMobileScreen) ?
        <div className='subjectHeaderSearch'>
          <CommonSearch
            handleSearchDebounce={handleSearchDebounce}
            searchValue={searchValue}
            setSearchValue={setSearchValue}
            from={`SubjectHeader`}
          />
          <img src={searchCloseIcon} alt='closeIcon' className='closeIcon' onClick={handleCloseSearch} />
        </div>
        :
        <div className={(tabName === 'Question Bank' && subCategory) ? 'subjectHeaderMainContainerQsBank' : 'subjectHeaderMainContainer'}>
          {(openPdf || (openStudentAssignments && role === TEACHER_ROLE && tabName === "Submitted  Assignment")) ?
            <div className='backIconContainer' onClick={onClose}>
              <img src={exitIcon} alt='backIcon' className='backIcon' />
            </div>
            :
            <div className='backIconContainer' onClick={backNavigationCall}>
              <img src={exitIcon} alt='backIcon' className='backIcon' />
            </div>
          }
          <div className='headerNameContainer'>
            <div className='headerImageContainer' style={{ backgroundColor: headerImage ? "none" : backgroundColor }}>
              {
                headerImage ?
                  <img src={headerImage} alt='headerImage' className='headerImageStyle' />
                  :
                  <div className='colorChange' style={{ backgroundColor: backgroundColor }}>
                    <span className='subjectHeader'>{headerName?.charAt(0).toUpperCase()}</span>
                  </div>
              }

            </div>
            <Tooltip
              title={
                isEllipsisActive
                  ? `${headerName}${tabName === "Submitted  Assignment"
                    ? " / Assignments"
                    : (tabName === "Quiz" || tabName === "Question Bank") && tabName
                      ? ` / ${tabName}`
                      : ""
                  }${subCategory ? ` / ${subCategory}` : ""}`
                  : ""
              }
            >
              <div
                ref={textRef}
                className="headerNameStyle"
                onMouseEnter={checkEllipsis} // Check ellipsis when hovered
              >
                <span className="headerName">
                  {headerName}
                  {tabName === "Submitted  Assignment"
                    ? " / Assignments"
                    : (tabName === "Quiz" || tabName === "Question Bank") && tabName
                      ? ` / ${tabName}`
                      : ""}
                  {subCategory && ` / ${subCategory}`}
                </span>
              </div>
            </Tooltip>       </div>
            <div className='back-text'>Back</div>
        </div>
      }
      {getScreenDimensions()?.isMobileScreen && <MobileHeader />}
    </div>
  )
}

export default SubjectHeader;
